/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do the colours mean?`)
};

const es_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significan los colores?`)
};

const de_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeuten die Farben?`)
};

const nl_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekenen de kleuren?`)
};

const fr_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifient les couleurs ?`)
};

const it_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significano i colori?`)
};

const pt_br2_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que as cores significam?`)
};

const pt_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significam as cores?`)
};

const ja_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色は何を意味しますか？`)
};

const zh_heat_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色代表什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_q2", locale)
	if (locale === "en") return en_heat_faq_q2(inputs)
	if (locale === "es") return es_heat_faq_q2(inputs)
	if (locale === "de") return de_heat_faq_q2(inputs)
	if (locale === "nl") return nl_heat_faq_q2(inputs)
	if (locale === "fr") return fr_heat_faq_q2(inputs)
	if (locale === "it") return it_heat_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_q2(inputs)
	if (locale === "pt") return pt_heat_faq_q2(inputs)
	if (locale === "ja") return ja_heat_faq_q2(inputs)
	return zh_heat_faq_q2(inputs)
};